import { render, staticRenderFns } from "./SenderCell.vue?vue&type=template&id=04486512&"
import script from "./SenderCell.vue?vue&type=script&lang=js&"
export * from "./SenderCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports